export default {
  ru: {
    mail: 'Электронная почта:',
    number: 'Регистрационный номер:',
    addres: 'Адрес:',
    social: `Официальные аккаунты
        <br>
        в социальных сетях`
  },
  en: {
    mail: 'E-mail:',
    number: 'Registration number:',
    addres: 'Address:',
    social: `Official accounts <br> in social networks`
  },
  ua: {
    mail: 'Електронна пошта:',
    number: 'Реєстраційний номер:',
    addres: 'Адреса:',
    social: `Офіційні акаунти
        <br>
        в соціальних мережах`
  },
  kz: {
    mail: 'Электрондық пошта:',
    number: 'Регистрационный номер:',
    addres: 'Адрес:',
    social: `Әлеуметтік желілердегі
        <br>
        ресми аккаунттар`
  }
}
